<mat-card *ngIf="report">
    <mat-card-header>
        <mat-card-title>
            <h2>
                {{'reports.exports.custom.shortLabel' | translate}}
                <app-tooltip text="{{'main.nav.links.reports.summary' | translate}}"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content [ngClass]="{hidden: isPrintMode}">
        <button mat-raised-button color="accent" (click)="onExportPpt()">
            <mat-icon aria-label="File">insert_drive_file</mat-icon>
            {{ 'reports.exports.ppt.shortLabel' | translate }}
        </button>

        <mat-tab-group #tabs animationDuration="0ms">
            <mat-tab label="{{ 'reports.categories.asis.shortLabel' | translate }}">
                <div class="report-content">
                    <ng-container *ngFor="let item of report.reportItems">
                        <section *ngIf="item.reportType.code === reportType.asis">
                            <app-report-variation-select [reportItem]="item"></app-report-variation-select>
                        </section>
                    </ng-container>
                </div>
            </mat-tab>

            <mat-tab label="{{ 'reports.categories.kpi.shortLabel' | translate }}">
                <div class="report-content">
                    <ng-container *ngFor="let item of report.reportItems">
                        <section *ngIf="item.reportType.code === reportType.kpi">
                            <app-report-variation-select [reportItem]="item"></app-report-variation-select>
                        </section>
                    </ng-container>
                </div>
            </mat-tab>

            <mat-tab *ngIf="report.organismGroups && report.organismGroups.length"  label="{{ 'reports.categories.sample.shortLabel' | translate }}">
                <div class="report-content">
                    <section class="grouping" *ngFor="let group of report.organismGroups">
                        <app-report-sample [group]="group"></app-report-sample>
                    </section>
                </div>
            </mat-tab>

            <mat-tab *ngFor="let report of customReports; index as i">
                <ng-template mat-tab-label>
                    {{ 'reports.categories.custom.shortLabel' | translate }} {{i + 1}}
                    <mat-icon *ngIf="i > 0" class="remove-tab-icon" (click)="onRemoveCustom(i)">close</mat-icon>
                </ng-template>
                <div class="report-content">
                    <app-report-custom [report]="report" [selMode]="selMode"></app-report-custom>
                </div>
            </mat-tab>

            <mat-tab disabled>
                <ng-template mat-tab-label>
                    <mat-icon class="add-tab-icon" (click)="onAddCustom()">add</mat-icon>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </mat-card-content>

    <app-report-print [report]="report" [customReports]="customReports" [selMode]="selMode"></app-report-print>
</mat-card>
